import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';

export const SponsoredSplashQuickViewAtom = mediatorAtom<{
    isOpen: boolean;
    productId?: number;
}>({
    isOpen: false
});

export default function useSponsoredSplashQuickView() {
    return useMediatorState(SponsoredSplashQuickViewAtom);
}
